"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/cms_service.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSGoodsServiceDeleteSelfShippingGoodsResponse = exports.CMSGoodsServiceDeleteSelfShippingGoodsRequest = exports.CMSGoodsServiceUpdateVariantSelfShippingAllResponse = exports.CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant = exports.CMSGoodsServiceUpdateVariantSelfShippingAllRequest = exports.CMSGoodsServiceUpdateSelfShippingGoodsResponse = exports.CMSGoodsServiceUpdateSelfShippingGoodsRequest = exports.CMSGoodsServiceCreateSelfShippingGoodsResponse = exports.CMSGoodsVariantSelfShippingVariantRequest = exports.CMSCreateSelfShippingImageRequest = exports.CMSGoodsServiceCreateSelfShippingGoodsRequest = exports.CMSGoodsVariantSelfShippingRequest = exports.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse = exports.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest = exports.CMSGoodsServiceUpdateVariantDigitalAllResponse = exports.CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File = exports.CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant = exports.CMSGoodsServiceUpdateVariantDigitalAllRequest = exports.CMSGoodsServiceCreateDigitalGoodsResponse = exports.CMSGoodsVariantDigitalVariantRequest_File = exports.CMSGoodsVariantDigitalVariantRequest = exports.CMSCreateDigitalImageRequest = exports.CMSGoodsServiceDeleteDigitalGoodsResponse = exports.CMSGoodsServiceDeleteDigitalGoodsRequest = exports.CMSGoodsServiceUpdateGoodsAllResponse = exports.CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll = exports.CMSGoodsServiceUpdateGoodsAllRequest = exports.CMSGoodsServiceUpdateDigitalGoodsResponse = exports.CMSGoodsServiceUpdateDigitalGoodsRequest = exports.CMSGoodsServiceCreateDigitalGoodsRequest = exports.CMSGoodsServiceGetGoodsListResponse_Items = exports.CMSGoodsServiceGetGoodsListResponse = exports.CMSGoodsServiceGetGoodsListRequest = exports.CMSGoodsServiceGetAllGoodsResponse_Items = exports.CMSGoodsServiceGetAllGoodsResponse = exports.CMSGoodsServiceGetAllGoodsRequest = exports.CMSGoodsServiceGetGoodsResponse = exports.CMSGoodsServiceGetGoodsRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const cms_common_pb_1 = require("./cms_common_pb");
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetGoodsRequest
 */
class CMSGoodsServiceGetGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceGetGoodsRequest = CMSGoodsServiceGetGoodsRequest;
CMSGoodsServiceGetGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceGetGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceGetGoodsRequest";
CMSGoodsServiceGetGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetGoodsResponse
 */
class CMSGoodsServiceGetGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigital variants = 2;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceGetGoodsResponse = CMSGoodsServiceGetGoodsResponse;
CMSGoodsServiceGetGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceGetGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceGetGoodsResponse";
CMSGoodsServiceGetGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: cms_common_pb_1.CMSGoods },
    { no: 2, name: "variants", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigital, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetAllGoodsRequest
 */
class CMSGoodsServiceGetAllGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsStatus statuses = 2;
         */
        this.statuses = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetAllGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetAllGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetAllGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetAllGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceGetAllGoodsRequest = CMSGoodsServiceGetAllGoodsRequest;
CMSGoodsServiceGetAllGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceGetAllGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceGetAllGoodsRequest";
CMSGoodsServiceGetAllGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "statuses", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsStatus), repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetAllGoodsResponse
 */
class CMSGoodsServiceGetAllGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsServiceGetAllGoodsResponse.Items items = 1;
         */
        this.items = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetAllGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetAllGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetAllGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetAllGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceGetAllGoodsResponse = CMSGoodsServiceGetAllGoodsResponse;
CMSGoodsServiceGetAllGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceGetAllGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceGetAllGoodsResponse";
CMSGoodsServiceGetAllGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: CMSGoodsServiceGetAllGoodsResponse_Items, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetAllGoodsResponse.Items
 */
class CMSGoodsServiceGetAllGoodsResponse_Items extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigital variants = 2;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetAllGoodsResponse_Items().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetAllGoodsResponse_Items().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetAllGoodsResponse_Items().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetAllGoodsResponse_Items, a, b);
    }
}
exports.CMSGoodsServiceGetAllGoodsResponse_Items = CMSGoodsServiceGetAllGoodsResponse_Items;
CMSGoodsServiceGetAllGoodsResponse_Items.runtime = protobuf_1.proto3;
CMSGoodsServiceGetAllGoodsResponse_Items.typeName = "spwn.goods.v1.CMSGoodsServiceGetAllGoodsResponse.Items";
CMSGoodsServiceGetAllGoodsResponse_Items.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: cms_common_pb_1.CMSGoods },
    { no: 2, name: "variants", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigital, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetGoodsListRequest
 */
class CMSGoodsServiceGetGoodsListRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: int32 page = 2;
         */
        this.page = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetGoodsListRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetGoodsListRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetGoodsListRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetGoodsListRequest, a, b);
    }
}
exports.CMSGoodsServiceGetGoodsListRequest = CMSGoodsServiceGetGoodsListRequest;
CMSGoodsServiceGetGoodsListRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceGetGoodsListRequest.typeName = "spwn.goods.v1.CMSGoodsServiceGetGoodsListRequest";
CMSGoodsServiceGetGoodsListRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetGoodsListResponse
 */
class CMSGoodsServiceGetGoodsListResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsServiceGetGoodsListResponse.Items items = 1;
         */
        this.items = [];
        /**
         * @generated from field: int32 total_pages = 2;
         */
        this.totalPages = 0;
        /**
         * @generated from field: int32 current_page = 3;
         */
        this.currentPage = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetGoodsListResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetGoodsListResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetGoodsListResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetGoodsListResponse, a, b);
    }
}
exports.CMSGoodsServiceGetGoodsListResponse = CMSGoodsServiceGetGoodsListResponse;
CMSGoodsServiceGetGoodsListResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceGetGoodsListResponse.typeName = "spwn.goods.v1.CMSGoodsServiceGetGoodsListResponse";
CMSGoodsServiceGetGoodsListResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: CMSGoodsServiceGetGoodsListResponse_Items, repeated: true },
    { no: 2, name: "total_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetGoodsListResponse.Items
 */
class CMSGoodsServiceGetGoodsListResponse_Items extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigital variants = 2;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetGoodsListResponse_Items().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetGoodsListResponse_Items().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetGoodsListResponse_Items().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetGoodsListResponse_Items, a, b);
    }
}
exports.CMSGoodsServiceGetGoodsListResponse_Items = CMSGoodsServiceGetGoodsListResponse_Items;
CMSGoodsServiceGetGoodsListResponse_Items.runtime = protobuf_1.proto3;
CMSGoodsServiceGetGoodsListResponse_Items.typeName = "spwn.goods.v1.CMSGoodsServiceGetGoodsListResponse.Items";
CMSGoodsServiceGetGoodsListResponse_Items.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: cms_common_pb_1.CMSGoods },
    { no: 2, name: "variants", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigital, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceCreateDigitalGoodsRequest
 */
class CMSGoodsServiceCreateDigitalGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID FEから渡されたIDグッズIDを決める
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.CMSGoodsType type = 2;
         */
        this.type = cms_common_pb_1.CMSGoodsType.CMS_GOODS_TYPE_UNSPECIFIED;
        /**
         * 公開ステータス
         *
         * @generated from field: spwn.goods.v1.CMSGoodsStatus status = 3;
         */
        this.status = cms_common_pb_1.CMSGoodsStatus.CMS_GOODS_STATUS_UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 4;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 5;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 6;
         */
        this.price = 0;
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 9;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.CMSCreateDigitalImageRequest images = 10;
         */
        this.images = [];
        /**
         * 販売時のバリエーション
         * 公開時は必ず1つ以上のバリエーションが存在する
         *
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigitalVariantRequest variants = 11;
         */
        this.variants = [];
        /**
         * 公開設定の詳細
         *
         * @generated from field: bool has_detail = 12;
         */
        this.hasDetail = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceCreateDigitalGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceCreateDigitalGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceCreateDigitalGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceCreateDigitalGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceCreateDigitalGoodsRequest = CMSGoodsServiceCreateDigitalGoodsRequest;
CMSGoodsServiceCreateDigitalGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceCreateDigitalGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceCreateDigitalGoodsRequest";
CMSGoodsServiceCreateDigitalGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsType) },
    { no: 3, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsStatus) },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "images", kind: "message", T: CMSCreateDigitalImageRequest, repeated: true },
    { no: 11, name: "variants", kind: "message", T: CMSGoodsVariantDigitalVariantRequest, repeated: true },
    { no: 12, name: "has_detail", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateDigitalGoodsRequest
 */
class CMSGoodsServiceUpdateDigitalGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 対象のグッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 公開ステータス
         *
         * @generated from field: spwn.goods.v1.CMSGoodsStatus status = 2;
         */
        this.status = cms_common_pb_1.CMSGoodsStatus.CMS_GOODS_STATUS_UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 4;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 5;
         */
        this.price = 0;
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 8;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * 公開設定の詳細
         *
         * @generated from field: bool has_detail = 9;
         */
        this.hasDetail = false;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.CMSCreateDigitalImageRequest images = 10;
         */
        this.images = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateDigitalGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateDigitalGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateDigitalGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateDigitalGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceUpdateDigitalGoodsRequest = CMSGoodsServiceUpdateDigitalGoodsRequest;
CMSGoodsServiceUpdateDigitalGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateDigitalGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateDigitalGoodsRequest";
CMSGoodsServiceUpdateDigitalGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsStatus) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "has_detail", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "images", kind: "message", T: CMSCreateDigitalImageRequest, repeated: true },
    { no: 11, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateDigitalGoodsResponse
 */
class CMSGoodsServiceUpdateDigitalGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateDigitalGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateDigitalGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateDigitalGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateDigitalGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceUpdateDigitalGoodsResponse = CMSGoodsServiceUpdateDigitalGoodsResponse;
CMSGoodsServiceUpdateDigitalGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateDigitalGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateDigitalGoodsResponse";
CMSGoodsServiceUpdateDigitalGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: cms_common_pb_1.CMSGoods },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateGoodsAllRequest
 */
class CMSGoodsServiceUpdateGoodsAllRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsServiceUpdateGoodsAllRequest.UpdateGoodsAll goods_list = 1;
         */
        this.goodsList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateGoodsAllRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateGoodsAllRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateGoodsAllRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateGoodsAllRequest, a, b);
    }
}
exports.CMSGoodsServiceUpdateGoodsAllRequest = CMSGoodsServiceUpdateGoodsAllRequest;
CMSGoodsServiceUpdateGoodsAllRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateGoodsAllRequest.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateGoodsAllRequest";
CMSGoodsServiceUpdateGoodsAllRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_list", kind: "message", T: CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateGoodsAllRequest.UpdateGoodsAll
 */
class CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 順番 降順
         *
         * @generated from field: int32 priority = 2;
         */
        this.priority = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll, a, b);
    }
}
exports.CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll = CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll;
CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateGoodsAllRequest.UpdateGoodsAll";
CMSGoodsServiceUpdateGoodsAllRequest_UpdateGoodsAll.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateGoodsAllResponse
 */
class CMSGoodsServiceUpdateGoodsAllResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新されたグッズのリスト
         * priorityの降順で返却される
         *
         * @generated from field: repeated spwn.goods.v1.CMSGoods goods_list = 1;
         */
        this.goodsList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateGoodsAllResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateGoodsAllResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateGoodsAllResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateGoodsAllResponse, a, b);
    }
}
exports.CMSGoodsServiceUpdateGoodsAllResponse = CMSGoodsServiceUpdateGoodsAllResponse;
CMSGoodsServiceUpdateGoodsAllResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateGoodsAllResponse.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateGoodsAllResponse";
CMSGoodsServiceUpdateGoodsAllResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_list", kind: "message", T: cms_common_pb_1.CMSGoods, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceDeleteDigitalGoodsRequest
 */
class CMSGoodsServiceDeleteDigitalGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceDeleteDigitalGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceDeleteDigitalGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceDeleteDigitalGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceDeleteDigitalGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceDeleteDigitalGoodsRequest = CMSGoodsServiceDeleteDigitalGoodsRequest;
CMSGoodsServiceDeleteDigitalGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceDeleteDigitalGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceDeleteDigitalGoodsRequest";
CMSGoodsServiceDeleteDigitalGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceDeleteDigitalGoodsResponse
 */
class CMSGoodsServiceDeleteDigitalGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceDeleteDigitalGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceDeleteDigitalGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceDeleteDigitalGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceDeleteDigitalGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceDeleteDigitalGoodsResponse = CMSGoodsServiceDeleteDigitalGoodsResponse;
CMSGoodsServiceDeleteDigitalGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceDeleteDigitalGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceDeleteDigitalGoodsResponse";
CMSGoodsServiceDeleteDigitalGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSCreateDigitalImageRequest
 */
class CMSCreateDigitalImageRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズ画像のURL
         *
         * @generated from field: string src = 1;
         */
        this.src = "";
        /**
         * 順番 昇順
         *
         * @generated from field: int32 position = 2;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSCreateDigitalImageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSCreateDigitalImageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSCreateDigitalImageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSCreateDigitalImageRequest, a, b);
    }
}
exports.CMSCreateDigitalImageRequest = CMSCreateDigitalImageRequest;
CMSCreateDigitalImageRequest.runtime = protobuf_1.proto3;
CMSCreateDigitalImageRequest.typeName = "spwn.goods.v1.CMSCreateDigitalImageRequest";
CMSCreateDigitalImageRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantDigitalVariantRequest
 */
class CMSGoodsVariantDigitalVariantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 3;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.CMSInventoryPolicy inventory_policy = 4;
         */
        this.inventoryPolicy = cms_common_pb_1.CMSInventoryPolicy.CMS_INVENTORY_POLICY_UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigitalVariantRequest.File files = 5;
         */
        this.files = [];
        /**
         * @generated from field: int32 position = 6;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantDigitalVariantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantDigitalVariantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantDigitalVariantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantDigitalVariantRequest, a, b);
    }
}
exports.CMSGoodsVariantDigitalVariantRequest = CMSGoodsVariantDigitalVariantRequest;
CMSGoodsVariantDigitalVariantRequest.runtime = protobuf_1.proto3;
CMSGoodsVariantDigitalVariantRequest.typeName = "spwn.goods.v1.CMSGoodsVariantDigitalVariantRequest";
CMSGoodsVariantDigitalVariantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigitalImage },
    { no: 3, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSInventoryPolicy) },
    { no: 5, name: "files", kind: "message", T: CMSGoodsVariantDigitalVariantRequest_File, repeated: true },
    { no: 6, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * デジタルグッズの実態で、ダウンロード可能なファイル
 *
 * @generated from message spwn.goods.v1.CMSGoodsVariantDigitalVariantRequest.File
 */
class CMSGoodsVariantDigitalVariantRequest_File extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        /**
         * @generated from field: string src = 2;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantDigitalVariantRequest_File().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantDigitalVariantRequest_File().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantDigitalVariantRequest_File().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantDigitalVariantRequest_File, a, b);
    }
}
exports.CMSGoodsVariantDigitalVariantRequest_File = CMSGoodsVariantDigitalVariantRequest_File;
CMSGoodsVariantDigitalVariantRequest_File.runtime = protobuf_1.proto3;
CMSGoodsVariantDigitalVariantRequest_File.typeName = "spwn.goods.v1.CMSGoodsVariantDigitalVariantRequest.File";
CMSGoodsVariantDigitalVariantRequest_File.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceCreateDigitalGoodsResponse
 */
class CMSGoodsServiceCreateDigitalGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigital variants = 2;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceCreateDigitalGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceCreateDigitalGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceCreateDigitalGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceCreateDigitalGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceCreateDigitalGoodsResponse = CMSGoodsServiceCreateDigitalGoodsResponse;
CMSGoodsServiceCreateDigitalGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceCreateDigitalGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceCreateDigitalGoodsResponse";
CMSGoodsServiceCreateDigitalGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: cms_common_pb_1.CMSGoods },
    { no: 2, name: "variants", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigital, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest
 */
class CMSGoodsServiceUpdateVariantDigitalAllRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 対象のグッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest.Variant variants = 2;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateVariantDigitalAllRequest, a, b);
    }
}
exports.CMSGoodsServiceUpdateVariantDigitalAllRequest = CMSGoodsServiceUpdateVariantDigitalAllRequest;
CMSGoodsServiceUpdateVariantDigitalAllRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateVariantDigitalAllRequest.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest";
CMSGoodsServiceUpdateVariantDigitalAllRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "variants", kind: "message", T: CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest.Variant
 */
class CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * idがなければ新規作成
         * idがあれば更新
         * 元々あるものでid指定されていなければ削除
         *
         * @generated from field: string variant_id = 1;
         */
        this.variantId = "";
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 4;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.CMSInventoryPolicy inventory_policy = 5;
         */
        this.inventoryPolicy = cms_common_pb_1.CMSInventoryPolicy.CMS_INVENTORY_POLICY_UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest.Variant.File files = 6;
         */
        this.files = [];
        /**
         * 並び順 1から昇順
         *
         * @generated from field: int32 position = 7;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant, a, b);
    }
}
exports.CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant = CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant;
CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest.Variant";
CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigitalImage },
    { no: 4, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSInventoryPolicy) },
    { no: 6, name: "files", kind: "message", T: CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File, repeated: true },
    { no: 7, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * デジタルグッズの実態で、ダウンロード可能なファイル
 *
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest.Variant.File
 */
class CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        /**
         * @generated from field: string src = 2;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File, a, b);
    }
}
exports.CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File = CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File;
CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllRequest.Variant.File";
CMSGoodsServiceUpdateVariantDigitalAllRequest_Variant_File.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllResponse
 */
class CMSGoodsServiceUpdateVariantDigitalAllResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigital variants = 1;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateVariantDigitalAllResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateVariantDigitalAllResponse, a, b);
    }
}
exports.CMSGoodsServiceUpdateVariantDigitalAllResponse = CMSGoodsServiceUpdateVariantDigitalAllResponse;
CMSGoodsServiceUpdateVariantDigitalAllResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateVariantDigitalAllResponse.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateVariantDigitalAllResponse";
CMSGoodsServiceUpdateVariantDigitalAllResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variants", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigital, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest
 */
class CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファイル名
         *
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest, a, b);
    }
}
exports.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest = CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest;
CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest.typeName = "spwn.goods.v1.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest";
CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse
 */
class CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        /**
         * アップロード時に指定するヘッダー
         *
         * @generated from field: map<string, string> headers_for_upload = 2;
         */
        this.headersForUpload = {};
        /**
         * アップロード用のURL
         *
         * @generated from field: string url_for_upload = 3;
         */
        this.urlForUpload = "";
        /**
         * ダウンロード用のURL
         *
         * @generated from field: string url_for_download = 4;
         */
        this.urlForDownload = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse, a, b);
    }
}
exports.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse = CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse;
CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse.typeName = "spwn.goods.v1.CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse";
CMSGoodsServiceGetSignedUrlForDigitalGoodsFileUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "headers_for_upload", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "url_for_upload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantSelfShippingRequest
 */
class CMSGoodsVariantSelfShippingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 3;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.CMSInventoryPolicy inventory_policy = 4;
         */
        this.inventoryPolicy = cms_common_pb_1.CMSInventoryPolicy.CMS_INVENTORY_POLICY_UNSPECIFIED;
        /**
         * 並び順
         *
         * @generated from field: int32 position = 5;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantSelfShippingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantSelfShippingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantSelfShippingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantSelfShippingRequest, a, b);
    }
}
exports.CMSGoodsVariantSelfShippingRequest = CMSGoodsVariantSelfShippingRequest;
CMSGoodsVariantSelfShippingRequest.runtime = protobuf_1.proto3;
CMSGoodsVariantSelfShippingRequest.typeName = "spwn.goods.v1.CMSGoodsVariantSelfShippingRequest";
CMSGoodsVariantSelfShippingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigitalImage },
    { no: 3, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSInventoryPolicy) },
    { no: 5, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceCreateSelfShippingGoodsRequest
 */
class CMSGoodsServiceCreateSelfShippingGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID FEから渡されたID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.CMSGoodsType type = 2;
         */
        this.type = cms_common_pb_1.CMSGoodsType.CMS_GOODS_TYPE_UNSPECIFIED;
        /**
         * 公開ステータス
         *
         * @generated from field: spwn.goods.v1.CMSGoodsStatus status = 3;
         */
        this.status = cms_common_pb_1.CMSGoodsStatus.CMS_GOODS_STATUS_UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 4;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 5;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 6;
         */
        this.price = 0;
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 9;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.CMSCreateSelfShippingImageRequest images = 10;
         */
        this.images = [];
        /**
         * 販売時のバリエーション
         * 公開時は必ず1つ以上のバリエーションが存在する
         *
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantSelfShippingRequest variants = 11;
         */
        this.variants = [];
        /**
         * 公開設定の詳細
         *
         * @generated from field: bool has_detail = 12;
         */
        this.hasDetail = false;
        /**
         * 販売方法
         *
         * @generated from field: spwn.goods.v1.CMSGoodsSalesType sales_type = 13;
         */
        this.salesType = cms_common_pb_1.CMSGoodsSalesType.CMS_GOODS_SALES_TYPE_UNSPECIFIED;
        /**
         * 配送料
         *
         * @generated from field: double shipping_fee = 17;
         */
        this.shippingFee = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceCreateSelfShippingGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceCreateSelfShippingGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceCreateSelfShippingGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceCreateSelfShippingGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceCreateSelfShippingGoodsRequest = CMSGoodsServiceCreateSelfShippingGoodsRequest;
CMSGoodsServiceCreateSelfShippingGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceCreateSelfShippingGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceCreateSelfShippingGoodsRequest";
CMSGoodsServiceCreateSelfShippingGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsType) },
    { no: 3, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsStatus) },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "images", kind: "message", T: CMSCreateSelfShippingImageRequest, repeated: true },
    { no: 11, name: "variants", kind: "message", T: CMSGoodsVariantSelfShippingRequest, repeated: true },
    { no: 12, name: "has_detail", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "sales_type", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsSalesType) },
    { no: 14, name: "shipping_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "minimum_shipping_days", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "maximum_shipping_days", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSCreateSelfShippingImageRequest
 */
class CMSCreateSelfShippingImageRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズ画像のURL
         *
         * @generated from field: string src = 1;
         */
        this.src = "";
        /**
         * 順番 昇順
         *
         * @generated from field: int32 position = 2;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSCreateSelfShippingImageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSCreateSelfShippingImageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSCreateSelfShippingImageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSCreateSelfShippingImageRequest, a, b);
    }
}
exports.CMSCreateSelfShippingImageRequest = CMSCreateSelfShippingImageRequest;
CMSCreateSelfShippingImageRequest.runtime = protobuf_1.proto3;
CMSCreateSelfShippingImageRequest.typeName = "spwn.goods.v1.CMSCreateSelfShippingImageRequest";
CMSCreateSelfShippingImageRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantSelfShippingVariantRequest
 */
class CMSGoodsVariantSelfShippingVariantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 3;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.CMSInventoryPolicy inventory_policy = 4;
         */
        this.inventoryPolicy = cms_common_pb_1.CMSInventoryPolicy.CMS_INVENTORY_POLICY_UNSPECIFIED;
        /**
         * 並び順 1から昇順
         *
         * @generated from field: int32 position = 5;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantSelfShippingVariantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantSelfShippingVariantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantSelfShippingVariantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantSelfShippingVariantRequest, a, b);
    }
}
exports.CMSGoodsVariantSelfShippingVariantRequest = CMSGoodsVariantSelfShippingVariantRequest;
CMSGoodsVariantSelfShippingVariantRequest.runtime = protobuf_1.proto3;
CMSGoodsVariantSelfShippingVariantRequest.typeName = "spwn.goods.v1.CMSGoodsVariantSelfShippingVariantRequest";
CMSGoodsVariantSelfShippingVariantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image", kind: "message", T: cms_common_pb_1.CMSGoodsVariantImage },
    { no: 3, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSInventoryPolicy) },
    { no: 5, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceCreateSelfShippingGoodsResponse
 */
class CMSGoodsServiceCreateSelfShippingGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceCreateSelfShippingGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceCreateSelfShippingGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceCreateSelfShippingGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceCreateSelfShippingGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceCreateSelfShippingGoodsResponse = CMSGoodsServiceCreateSelfShippingGoodsResponse;
CMSGoodsServiceCreateSelfShippingGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceCreateSelfShippingGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceCreateSelfShippingGoodsResponse";
CMSGoodsServiceCreateSelfShippingGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: cms_common_pb_1.CMSGoods },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateSelfShippingGoodsRequest
 */
class CMSGoodsServiceUpdateSelfShippingGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 対象のグッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 公開ステータス
         *
         * @generated from field: spwn.goods.v1.CMSGoodsStatus status = 2;
         */
        this.status = cms_common_pb_1.CMSGoodsStatus.CMS_GOODS_STATUS_UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 4;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 5;
         */
        this.price = 0;
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 8;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * 公開設定の詳細
         *
         * @generated from field: bool has_detail = 9;
         */
        this.hasDetail = false;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.CMSCreateDigitalImageRequest images = 10;
         */
        this.images = [];
        /**
         * 販売方法
         *
         * @generated from field: spwn.goods.v1.CMSGoodsSalesType sales_type = 12;
         */
        this.salesType = cms_common_pb_1.CMSGoodsSalesType.CMS_GOODS_SALES_TYPE_UNSPECIFIED;
        /**
         * 配送料
         *
         * @generated from field: double shipping_fee = 16;
         */
        this.shippingFee = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateSelfShippingGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateSelfShippingGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateSelfShippingGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateSelfShippingGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceUpdateSelfShippingGoodsRequest = CMSGoodsServiceUpdateSelfShippingGoodsRequest;
CMSGoodsServiceUpdateSelfShippingGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateSelfShippingGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateSelfShippingGoodsRequest";
CMSGoodsServiceUpdateSelfShippingGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsStatus) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "has_detail", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "images", kind: "message", T: CMSCreateDigitalImageRequest, repeated: true },
    { no: 11, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 12, name: "sales_type", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSGoodsSalesType) },
    { no: 13, name: "shipping_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 14, name: "minimum_shipping_days", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "maximum_shipping_days", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateSelfShippingGoodsResponse
 */
class CMSGoodsServiceUpdateSelfShippingGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateSelfShippingGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateSelfShippingGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateSelfShippingGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateSelfShippingGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceUpdateSelfShippingGoodsResponse = CMSGoodsServiceUpdateSelfShippingGoodsResponse;
CMSGoodsServiceUpdateSelfShippingGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateSelfShippingGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateSelfShippingGoodsResponse";
CMSGoodsServiceUpdateSelfShippingGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: cms_common_pb_1.CMSGoods },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateVariantSelfShippingAllRequest
 */
class CMSGoodsServiceUpdateVariantSelfShippingAllRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 対象のグッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsServiceUpdateVariantSelfShippingAllRequest.Variant variants = 2;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateVariantSelfShippingAllRequest, a, b);
    }
}
exports.CMSGoodsServiceUpdateVariantSelfShippingAllRequest = CMSGoodsServiceUpdateVariantSelfShippingAllRequest;
CMSGoodsServiceUpdateVariantSelfShippingAllRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateVariantSelfShippingAllRequest.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateVariantSelfShippingAllRequest";
CMSGoodsServiceUpdateVariantSelfShippingAllRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "variants", kind: "message", T: CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateVariantSelfShippingAllRequest.Variant
 */
class CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * idがなければ新規作成
         * idがあれば更新
         * 元々あるものでid指定されていなければ削除
         *
         * @generated from field: string variant_id = 1;
         */
        this.variantId = "";
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 4;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.CMSInventoryPolicy inventory_policy = 5;
         */
        this.inventoryPolicy = cms_common_pb_1.CMSInventoryPolicy.CMS_INVENTORY_POLICY_UNSPECIFIED;
        /**
         * 並び順 1から昇順
         *
         * @generated from field: int32 position = 6;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant, a, b);
    }
}
exports.CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant = CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant;
CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateVariantSelfShippingAllRequest.Variant";
CMSGoodsServiceUpdateVariantSelfShippingAllRequest_Variant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "message", T: cms_common_pb_1.CMSGoodsVariantDigitalImage },
    { no: 4, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSInventoryPolicy) },
    { no: 6, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceUpdateVariantSelfShippingAllResponse
 */
class CMSGoodsServiceUpdateVariantSelfShippingAllResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantSelfShipping variants = 1;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceUpdateVariantSelfShippingAllResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceUpdateVariantSelfShippingAllResponse, a, b);
    }
}
exports.CMSGoodsServiceUpdateVariantSelfShippingAllResponse = CMSGoodsServiceUpdateVariantSelfShippingAllResponse;
CMSGoodsServiceUpdateVariantSelfShippingAllResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceUpdateVariantSelfShippingAllResponse.typeName = "spwn.goods.v1.CMSGoodsServiceUpdateVariantSelfShippingAllResponse";
CMSGoodsServiceUpdateVariantSelfShippingAllResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variants", kind: "message", T: cms_common_pb_1.CMSGoodsVariantSelfShipping, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceDeleteSelfShippingGoodsRequest
 */
class CMSGoodsServiceDeleteSelfShippingGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceDeleteSelfShippingGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceDeleteSelfShippingGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceDeleteSelfShippingGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceDeleteSelfShippingGoodsRequest, a, b);
    }
}
exports.CMSGoodsServiceDeleteSelfShippingGoodsRequest = CMSGoodsServiceDeleteSelfShippingGoodsRequest;
CMSGoodsServiceDeleteSelfShippingGoodsRequest.runtime = protobuf_1.proto3;
CMSGoodsServiceDeleteSelfShippingGoodsRequest.typeName = "spwn.goods.v1.CMSGoodsServiceDeleteSelfShippingGoodsRequest";
CMSGoodsServiceDeleteSelfShippingGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsServiceDeleteSelfShippingGoodsResponse
 */
class CMSGoodsServiceDeleteSelfShippingGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsServiceDeleteSelfShippingGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsServiceDeleteSelfShippingGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsServiceDeleteSelfShippingGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsServiceDeleteSelfShippingGoodsResponse, a, b);
    }
}
exports.CMSGoodsServiceDeleteSelfShippingGoodsResponse = CMSGoodsServiceDeleteSelfShippingGoodsResponse;
CMSGoodsServiceDeleteSelfShippingGoodsResponse.runtime = protobuf_1.proto3;
CMSGoodsServiceDeleteSelfShippingGoodsResponse.typeName = "spwn.goods.v1.CMSGoodsServiceDeleteSelfShippingGoodsResponse";
CMSGoodsServiceDeleteSelfShippingGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=cms_service_pb.js.map